import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../apiConfig.js';
import { IoPersonAdd } from 'react-icons/io5';

// Web token helper
const getToken = () => {
  try { return localStorage.getItem('userToken'); } catch { return null; }
};

// Helper function to capitalize first letter
const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export default function Users() {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = getToken();
        if (!token) {
          alert('Please log in to view users.');
          navigate('/login');
          return;
        }
        
        const response = await axios.get(`${API_BASE_URL}/getUsers`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
        if (error.response?.status === 401) {
          alert('Your session has expired. Please log in again.');
          localStorage.removeItem('userToken');
          navigate('/login');
        } else {
          alert('Failed to load users. Please try again later.');
        }
      }
    };

    fetchUsers();
  }, [navigate]);

  const handleUserClick = (user) => {
    navigate('/user-details', { state: { user: user } });
  };

  return (
    <div style={styles.container}>
      <div style={styles.headerContainer}>
        <h1 style={styles.header}>Users</h1>
        <div style={styles.addUserButton} onClick={() => navigate('/add-user')}>
          <div style={{
            backgroundColor: '#007BFF',
            borderRadius: '5px',
            width: 30,
            height: 30,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '8px'
          }}>
            <IoPersonAdd size={18} color="white" />
          </div>
          <span style={styles.addUserButtonText}>Add User</span>
        </div>
      </div>
      <ul style={styles.list}>
        {users.map((user) => (
          <li key={user.id} style={styles.listItem}>
            <button style={styles.userButton} onClick={() => handleUserClick(user)}>
              <span style={styles.userName}>{`${user.firstName} ${user.lastName}`}</span>
              <span style={styles.userType}> - {capitalizeFirstLetter(user.userType)}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

const styles = {
  container: {
    padding: '20px',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    position: 'relative',
  },
  header: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px',
    textAlign: 'left',
    textDecoration: 'underline',
  },
  addUserButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'absolute',
    top: '10px',
    right: '10px',
    padding: '15px',
  },
  addUserButtonText: {
    fontSize: '16px',
    color: '#007BFF',
    fontWeight: 'bold',
  },
  list: {
    listStyleType: 'none',
    padding: 0,
  },
  listItem: {
    marginBottom: '10px',
  },
  userButton: {
    padding: '15px',
    backgroundColor: '#fff',
    color: '#007BFF',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    width: '100%',
    textAlign: 'left',
  },
  userName: {
    fontWeight: 'bold',
    color: '#007BFF',
    fontSize: '16px',
  },
  userType: {
    fontWeight: 'normal',
    color: '#007BFF',
    fontSize: '16px',
  },
};